export enum ImageFormats {
    PNG = 'png',
    JPEG = 'jpeg',
    SVG = 'svg',
    WebP = 'webp',
}

export enum ScreenshotType {
    Browser = 'Browser',
    Device = 'Device',
    None = 'None',
    Twitter = 'Twitter',
    Code = 'Code'
}

export enum CanvasBackgroundTypes {
    Image = 'Image',
    Solid = 'Solid',
    Gradient = 'Gradient',
    None = 'None',
}

export enum Browsers {
    Edge,
    Chrome,
    Firefox,
    Safari,
}

export enum SocialProviders {
    Facebook,
    Twitter,
    WhatsApp,
}